export const LEFT_HAND_PINCHING = [
  {t: [-0.05, -0.08, -0.1], r: [0.5373, 0, 0, 0.8434], s: [1, 1, 1]},
  {
    t: [-0.0281, -0.0594, -0.1165],
    r: [0.3072, -0.0483, -0.257, 0.915],
    s: [1, 1, 1],
  },
  {
    t: [-0.0083, -0.0299, -0.1581],
    r: [0.1832, 0.0632, -0.4718, 0.8602],
    s: [1, 1, 1],
  },
  {
    t: [-0.0069, -0.0195, -0.1841],
    r: [0.2232, 0.1362, -0.6112, 0.747],
    s: [1, 1, 0.9999],
  },
  {
    t: [-0.0063, -0.0051, -0.2109],
    r: [0.2232, 0.1362, -0.6112, 0.747],
    s: [1, 1, 0.9999],
  },
  {
    t: [-0.0369, -0.0541, -0.112],
    r: [0.5858, -0.1038, 0.0205, 0.8035],
    s: [1, 1, 1],
  },
  {
    t: [-0.024, 0.0142, -0.1465],
    r: [0.1342, -0.1392, -0.0707, 0.9786],
    s: [1.0001, 1, 0.9999],
  },
  {
    t: [-0.0122, 0.0248, -0.1828],
    r: [-0.2614, -0.0983, -0.1184, 0.9529],
    s: [1.0001, 0.9999, 0.9999],
  },
  {
    t: [-0.0095, 0.0131, -0.2017],
    r: [-0.3454, -0.0506, -0.1338, 0.9275],
    s: [1, 0.9999, 1],
  },
  {
    t: [-0.0098, -0.0028, -0.219],
    r: [-0.3454, -0.0506, -0.1338, 0.9275],
    s: [1, 0.9999, 1],
  },
  {
    t: [-0.0498, -0.0529, -0.1126],
    r: [0.5552, -0.0196, 0.0307, 0.8309],
    s: [1.0001, 1, 1],
  },
  {
    t: [-0.0496, 0.0131, -0.1444],
    r: [0.3957, -0.0669, 0.0916, 0.9113],
    s: [1, 0.9999, 1],
  },
  {
    t: [-0.0477, 0.0443, -0.173],
    r: [0.0284, -0.1256, 0.0276, 0.9913],
    s: [1, 1, 0.9999],
  },
  {
    t: [-0.0403, 0.0463, -0.2027],
    r: [-0.1956, -0.1387, -0.007, 0.9708],
    s: [1.0001, 1, 1],
  },
  {
    t: [-0.0339, 0.036, -0.224],
    r: [-0.1956, -0.1387, -0.007, 0.9708],
    s: [1.0001, 1, 1],
  },
  {
    t: [-0.0612, -0.0561, -0.1137],
    r: [0.5088, 0.0591, 0.0245, 0.8585],
    s: [1, 1.0001, 1],
  },
  {
    t: [-0.0697, 0.0021, -0.1467],
    r: [0.464, -0.0595, 0.1601, 0.8692],
    s: [1, 1, 1],
  },
  {
    t: [-0.0713, 0.0348, -0.1698],
    r: [0.0595, -0.1373, 0.0948, 0.9842],
    s: [1.0001, 1.0001, 1],
  },
  {
    t: [-0.0633, 0.0395, -0.2003],
    r: [-0.1735, -0.159, 0.0354, 0.9713],
    s: [1, 1, 0.9999],
  },
  {
    t: [-0.0561, 0.0313, -0.2197],
    r: [-0.1735, -0.159, 0.0354, 0.9713],
    s: [1, 1, 0.9999],
  },
  {
    t: [-0.0707, -0.0617, -0.1146],
    r: [0.4573, 0.1467, 0.0408, 0.8762],
    s: [1, 1, 1],
  },
  {
    t: [-0.0889, -0.0132, -0.148],
    r: [0.4065, 0.0051, 0.2314, 0.8838],
    s: [1, 0.9999, 1.0001],
  },
  {
    t: [-0.0946, 0.0109, -0.1723],
    r: [0.1595, -0.0578, 0.2175, 0.9612],
    s: [1, 0.9999, 1],
  },
  {
    t: [-0.094, 0.019, -0.1934],
    r: [-0.0122, -0.1189, 0.1509, 0.9813],
    s: [1.0001, 1, 1],
  },
  {
    t: [-0.0904, 0.0182, -0.2123],
    r: [-0.0122, -0.1189, 0.1509, 0.9813],
    s: [1.0001, 1, 1],
  },
] as const;

export const RIGHT_HAND_PINCHING = [
  {t: [0.05, -0.08, -0.1], r: [0.5373, 0, 0, 0.8434], s: [1, 1, 1]},
  {
    t: [0.0279, -0.0593, -0.1166],
    r: [0.307, 0.046, 0.2483, 0.9176],
    s: [1, 1, 1],
  },
  {
    t: [0.0082, -0.0291, -0.1587],
    r: [0.1833, -0.0669, 0.4657, 0.8632],
    s: [0.9999, 1, 1],
  },
  {
    t: [0.0071, -0.0186, -0.185],
    r: [0.2256, -0.1369, 0.6093, 0.7477],
    s: [1, 1, 0.9999],
  },
  {
    t: [0.0064, -0.0039, -0.212],
    r: [0.2256, -0.1369, 0.6093, 0.7477],
    s: [1, 1, 0.9999],
  },
  {
    t: [0.037, -0.0539, -0.1122],
    r: [0.5831, 0.1146, -0.0388, 0.8034],
    s: [1, 0.9999, 1],
  },
  {
    t: [0.0237, 0.0153, -0.147],
    r: [0.1209, 0.0891, 0.0196, 0.9885],
    s: [1, 0.9999, 1],
  },
  {
    t: [0.0163, 0.0257, -0.1849],
    r: [-0.2747, 0.0723, 0.0511, 0.9574],
    s: [1, 0.9999, 0.9999],
  },
  {
    t: [0.014, 0.0138, -0.204],
    r: [-0.3165, 0.0337, 0.0633, 0.9459],
    s: [1, 0.9999, 1],
  },
  {
    t: [0.0136, -0.0012, -0.2226],
    r: [-0.3165, 0.0337, 0.0633, 0.9459],
    s: [1, 0.9999, 1],
  },
  {
    t: [0.0501, -0.0527, -0.1126],
    r: [0.5625, 0.0291, -0.0455, 0.825],
    s: [1, 1, 1],
  },
  {
    t: [0.0497, 0.0141, -0.1449],
    r: [0.3465, 0.0658, -0.0921, 0.9312],
    s: [1.0001, 0.9999, 0.9999],
  },
  {
    t: [0.0473, 0.0424, -0.177],
    r: [0.0559, 0.1235, -0.0403, 0.9899],
    s: [1.0001, 1, 0.9999],
  },
  {
    t: [0.0402, 0.0463, -0.2069],
    r: [-0.0703, 0.1381, -0.0195, 0.9877],
    s: [1.0001, 1, 0.9999],
  },
  {
    t: [0.0335, 0.0419, -0.2304],
    r: [-0.0703, 0.1381, -0.0195, 0.9877],
    s: [1.0001, 1, 0.9999],
  },
  {
    t: [0.0615, -0.0561, -0.1136],
    r: [0.5287, -0.0513, -0.0363, 0.8465],
    s: [1.0001, 1, 0.9999],
  },
  {
    t: [0.07, 0.003, -0.1472],
    r: [0.4197, 0.0598, -0.1607, 0.8913],
    s: [1, 1, 0.9999],
  },
  {
    t: [0.0709, 0.0336, -0.1737],
    r: [0.1329, 0.1258, -0.1128, 0.9766],
    s: [1, 1, 1],
  },
  {
    t: [0.0643, 0.0431, -0.2038],
    r: [-0.0172, 0.145, -0.068, 0.9869],
    s: [1.0001, 0.9999, 1],
  },
  {
    t: [0.0577, 0.0418, -0.2253],
    r: [-0.0172, 0.145, -0.068, 0.9869],
    s: [1.0001, 0.9999, 1],
  },
  {
    t: [0.0711, -0.0617, -0.1145],
    r: [0.4861, -0.139, -0.0517, 0.8612],
    s: [1.0001, 0.9999, 1],
  },
  {
    t: [0.0893, -0.0125, -0.1485],
    r: [0.317, 0.0459, -0.2224, 0.9208],
    s: [1.0001, 0.9999, 1],
  },
  {
    t: [0.0902, 0.0078, -0.1772],
    r: [0.1921, 0.0784, -0.2077, 0.9559],
    s: [1, 1, 0.9999],
  },
  {
    t: [0.0889, 0.0174, -0.1979],
    r: [0.0936, 0.1253, -0.1462, 0.9768],
    s: [1.0001, 1, 1],
  },
  {
    t: [0.0857, 0.0208, -0.2167],
    r: [0.0936, 0.1253, -0.1462, 0.9768],
    s: [1.0001, 1, 1],
  },
] as const;
